export default "__VITE_ASSET__43498c8f__"